"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const UserIdentifyingFieldType_1 = require("../../enums/UserIdentifyingFieldType");
const ScenarioType_1 = require("../../enums/ScenarioType");
const ElementIds_1 = require("../../enums/ElementIds");
exports.default = vue_1.default.extend({
    name: 'user-identifying-field',
    props: {
        fieldType: {
            type: Number,
            default: UserIdentifyingFieldType_1.UserIdentifyingFieldType.MothersMaidenName,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        isSensitive: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        scenarioType: {
            type: Number,
            default: ScenarioType_1.ScenarioType.Unknown,
        },
        scenarioName: {
            type: String,
            default: '',
        },
        regex: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            states: [
                { label: 'AL', value: 'AL' },
                { label: 'AK', value: 'AK' },
                { label: 'AZ', value: 'AZ' },
                { label: 'AR', value: 'AR' },
                { label: 'CA', value: 'CA' },
                { label: 'CO', value: 'CO' },
                { label: 'CT', value: 'CT' },
                { label: 'DE', value: 'DE' },
                { label: 'FL', value: 'FL' },
                { label: 'GA', value: 'GA' },
                { label: 'HI', value: 'HI' },
                { label: 'ID', value: 'ID' },
                { label: 'IL', value: 'IL' },
                { label: 'IN', value: 'IN' },
                { label: 'IA', value: 'IA' },
                { label: 'KS', value: 'KS' },
                { label: 'KY', value: 'KY' },
                { label: 'LA', value: 'LA' },
                { label: 'ME', value: 'ME' },
                { label: 'MD', value: 'MD' },
                { label: 'MA', value: 'MA' },
                { label: 'MI', value: 'MI' },
                { label: 'MN', value: 'MN' },
                { label: 'MS', value: 'MS' },
                { label: 'MO', value: 'MO' },
                { label: 'MT', value: 'MT' },
                { label: 'NE', value: 'NE' },
                { label: 'NV', value: 'NV' },
                { label: 'NH', value: 'NH' },
                { label: 'NJ', value: 'NJ' },
                { label: 'NM', value: 'NM' },
                { label: 'NY', value: 'NY' },
                { label: 'NC', value: 'NC' },
                { label: 'ND', value: 'ND' },
                { label: 'OH', value: 'OH' },
                { label: 'OK', value: 'OK' },
                { label: 'OR', value: 'OR' },
                { label: 'PA', value: 'PA' },
                { label: 'RI', value: 'RI' },
                { label: 'SC', value: 'SC' },
                { label: 'SD', value: 'SD' },
                { label: 'TN', value: 'TN' },
                { label: 'TX', value: 'TX' },
                { label: 'UT', value: 'UT' },
                { label: 'VT', value: 'VT' },
                { label: 'VA', value: 'VA' },
                { label: 'WA', value: 'WA' },
                { label: 'WV', value: 'WV' },
                { label: 'WI', value: 'WI' },
                { label: 'WY', value: 'WY' },
            ],
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        inputVal: {
            get() {
                if (this.fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.IsBusiness) {
                    if (!this.value)
                        return false;
                    else {
                        if (this.value.toString() === 'True' || this.value.toString() === 'true')
                            return true;
                        else
                            return false;
                    }
                }
                return this.value;
            },
            set(val) {
                if (this.fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.IsBusiness) {
                    val = val === null ? 'false' : val.toString();
                }
                this.$emit('input', val.trim());
            },
        },
        elementIds() {
            return ElementIds_1.ElementIds;
        },
    },
    methods: {
        label(fieldType, scenarioType) {
            var sName = this.scenarioName === '' ? '' : this.scenarioName + '.';
            var scenarioTypeSpecificLabel = this.getSiteText(`${ScenarioType_1.ScenarioType[scenarioType]}.${sName}UserIdentifyingField.${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}.Label`);
            if (!scenarioTypeSpecificLabel.startsWith('__Localize_Me__'))
                return scenarioTypeSpecificLabel;
            return this.getSiteText(`UserIdentifyingField.${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}.Label`);
        },
        helperText(fieldType, scenarioType) {
            var sName = this.scenarioName === '' ? '' : this.scenarioName + '.';
            var scenarioTypeSpecificHelperText = this.getSiteText(`${ScenarioType_1.ScenarioType[scenarioType]}.${sName}UserIdentifyingField.${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}.HelperText`);
            if (!scenarioTypeSpecificHelperText.startsWith('__Localize_Me__'))
                return scenarioTypeSpecificHelperText;
            return this.getSiteText(`UserIdentifyingField.${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}.HelperText`);
        },
        requiredText(fieldType, scenarioType) {
            return `${this.getSiteText('UserIdentifyingField.Required', this.label(fieldType, scenarioType))}`;
        },
        optionalText() {
            return this.getSiteText('UserIdentifyingField.Optional');
        },
        isOfFieldType(fieldType, fieldTypeName) {
            return fieldTypeName === UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType];
        },
        validationRules(fieldType, scenarioType) {
            const regex = this.validationRegex(fieldType);
            if (regex !== null) {
                return [(value) => {
                        return value === '' || value === null || regex.test(value) || this.getSiteText('UserIdentifyingField.ErrorMessage', this.label(fieldType, scenarioType));
                    }];
            }
            else
                return null;
        },
        validationRegex(fieldType) {
            if (this.regex != null && this.regex.length > 0) {
                try {
                    return new RegExp(this.regex);
                }
                catch (ex) {
                    // A MatchRegEx is defined on the field but cannot be parsed.  Log an error and continue
                    // eslint-disable-next-line no-console
                    console.error(`Invalid regex for field ${this.scenarioName}: ${this.label(this.fieldType, this.scenarioType)}`);
                }
            }
            if (fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.TaxId || fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.EIN) {
                return /^(\d{3}-?\d{2}-?\d{4}|\d{1,9}|\d{2}-\d{7})$/;
            }
            else if (fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.HomePhone || fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.WorkPhone || fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.CellPhone) {
                return /^$|^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
            }
            else if (fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.Email) {
                return /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
            }
            else if (fieldType === UserIdentifyingFieldType_1.UserIdentifyingFieldType.State) {
                return /^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$/;
            }
            return null;
        },
        validationCheck(data) {
            this.$emit('validation-check', {
                fieldType: this.fieldType,
                isValid: data && Object.keys(data).length === 0, // Object.keys is intentional.  A blank textfield will return an empty object instead of an array
            });
        },
        getNameForField(fieldType) {
            return `${this.elementIds.UserIdentifyingField}_${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}`;
        },
        toggleHiddenText(fieldType, toggleMode) {
            const label = this.getSiteText(`UserIdentifyingField.${UserIdentifyingFieldType_1.UserIdentifyingFieldType[fieldType]}.Label`);
            const toggleText = this.getSiteText(`UserIdentifyingField.${toggleMode}`);
            if (!toggleText.startsWith('__Localize_Me__'))
                return `${toggleText} ${label}`;
            return `${toggleMode} ${label}`;
        },
        handleTextfieldFocus(event) {
            if (this.$store.getters.isMobile) {
                const currentScrollPosition = window.screenY || window.pageYOffset;
                const targetField = event.target;
                const textFieldPosition = targetField.getBoundingClientRect().top;
                window.scrollTo({
                    top: currentScrollPosition + textFieldPosition - window.innerHeight * 0.10,
                    behavior: 'smooth',
                });
            }
        },
    },
});
